/*
  rbk-theme-toggle.js — light/dark switch with persistence + premium transition.
  Default is LIGHT (an inline head script sets the initial theme before paint,
  so there's no flash). On toggle, uses the View Transitions API for a single
  smooth full-page crossfade where supported, and falls back to a brief global
  color transition otherwise. Honors prefers-reduced-motion. Event delegation
  handles toggle buttons rendered anywhere (header + mobile nav).
*/
(function () {
  var KEY = 'rbk-theme';
  var root = document.documentElement;

  function current() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function syncButtons() {
    var t = current();
    var btns = document.querySelectorAll('[data-rbk-theme-toggle]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', t === 'dark' ? 'true' : 'false');
      btns[i].setAttribute('aria-label', t === 'dark' ? 'Switch to light theme' : 'Switch to dark theme');
    }
  }

  function setTheme(theme) {
    root.setAttribute('data-theme', theme);
    try { localStorage.setItem(KEY, theme); } catch (e) { /* private mode */ }
    syncButtons();
  }

  function toggle() {
    var next = current() === 'dark' ? 'light' : 'dark';
    if (reduced()) { setTheme(next); return; }            // no motion: instant
    if (document.startViewTransition) {                   // premium: one smooth crossfade
      document.startViewTransition(function () { setTheme(next); });
    } else {                                              // fallback: brief global transition
      root.classList.add('rbk-theming');
      window.clearTimeout(toggle._t);
      toggle._t = window.setTimeout(function () { root.classList.remove('rbk-theming'); }, 750);
      setTheme(next);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rbk-theme-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    toggle();
  });

  if (document.readyState !== 'loading') syncButtons();
  else document.addEventListener('DOMContentLoaded', syncButtons);
})();
